import { useTranslation } from "react-i18next";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Globe } from "lucide-react";

const languages = [
  { code: "en", label: "EN" },
  { code: "ko", label: "한국어" },
  { code: "fr", label: "FR" },
  { code: "zh", label: "中文" },
  { code: "es", label: "ES" },
  { code: "ar", label: "العربية" },
  { code: "hi", label: "हिन्दी" },
  { code: "pt", label: "PT" },
  { code: "ru", label: "РУ" },
  { code: "ja", label: "日本語" },
  { code: "it", label: "IT" },
  { code: "de", label: "DE" },
  { code: "vi", label: "VI" },
  { code: "tl", label: "TL" },
  { code: "id", label: "ID" },
];

export default function LanguageSwitcher() {
  const { i18n } = useTranslation();

  return (
    <Select value={i18n.language?.substring(0, 2)} onValueChange={(v) => i18n.changeLanguage(v)}>
      <SelectTrigger aria-label="Select language" className="w-auto gap-1.5 h-8 px-2 text-xs bg-secondary border-border">
        <Globe className="w-3.5 h-3.5" />
        <SelectValue />
      </SelectTrigger>
      <SelectContent className="max-h-60">
        {languages.map((lang) => (
          <SelectItem key={lang.code} value={lang.code}>
            {lang.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
